import * as React from 'react'
import ReactPhoneInput from 'react-phone-input-2'
import { Controller, FormState } from 'react-hook-form'
import { useState } from 'react'
import { cls } from '../../../utils/utils'
import { phonePattern } from '../../Dialog/constants'
import { FormFields } from '../../Dialog/Dialog.types'
import { IPhoneInput } from '../TextInput.types'
import styles from '../TextInput.module.scss'
import 'react-phone-input-2/lib/high-res.css'

const validatePhone = (phone: string, isErrorExist: boolean, country?: string, isDirty?: boolean) => {
  const regex = RegExp(phonePattern)
  phone = phone.substring(0, 18)

  if (!regex.test(phone) || ((country === 'Portugal' || country === 'Uzbekistan') && phone.length !== 12)) {
    return isDirty || isErrorExist ? 'Phone is invalid.' : true
  }

  return true
}

const isFieldDirty = (name: string, getFieldState?: any, formState?: FormState<FormFields>): boolean => {
  return getFieldState(name, formState).isDirty
}

const PhoneInputTemplate: React.FC<IPhoneInput> = ({ name, errors, control, getFieldState, formState }) => {
  const [countryName, setCountryName] = useState('Portugal')
  return (
    <>
      {name === 'phone' && (
        <Controller
          control={control}
          name={name}
          rules={{
            required: true,
            validate: (value) => validatePhone(value, Boolean(errors && errors[name]), countryName, isFieldDirty(name, getFieldState, formState)),
          }}
          defaultValue={''}
          render={({ field: { onChange, value } }) => (
            <ReactPhoneInput
              inputProps={{ pattern: phonePattern, name, required: true }}
              country={'pt'}
              preferredCountries={['pt', 'uz']}
              value={value}
              onChange={(phone: string, country: any) => {
                setCountryName(country.name)
                onChange(phone)
              }}
              isValid={(val) => validatePhone(val, Boolean(errors && errors[name]), countryName, isFieldDirty(name, getFieldState, formState))}
              countryCodeEditable={true}
              containerClass={styles.phoneContainer}
              inputClass={cls(styles.input, styles.phoneInput, errors && errors[name] && styles.phoneInputInvalid)}
              buttonClass={styles.phoneButton}
              dropdownClass={styles.phoneDropdown}
              placeholder={'+351 12-345-6789'}
              masks={{ pt: '..-...-....' }}
              defaultMask={'...-...-...-..'}
            />
          )}
        />
      )}
    </>
  )
}

export default PhoneInputTemplate
